import { AdminInvestmentToken, AdminProductDetail, ProductPermissionEnum, User } from 'api';
import type { Product, InvestmentTokenForInvestor } from 'api';

type permissionsTokenType =
  | InvestmentTokenForInvestor
  | Product
  | AdminProductDetail
  | AdminInvestmentToken
  | null
  | undefined;

const userHasPermission = (user: User | null, permission: ProductPermissionEnum): boolean =>
  user?.permissionOnAtLeastOneProduct?.includes(permission) ?? false;

export const currentTokenHasPermission = (token: permissionsTokenType, permission: ProductPermissionEnum) =>
  !!token?.permissions.find((perm) => perm === permission);

export const hasViewPermission = (user: User | null) => userHasPermission(user, ProductPermissionEnum.VIEW_DATA);

export const hasManageCreditDigitalSecuritiesPermission = (user: User | null) =>
  userHasPermission(user, ProductPermissionEnum.MANAGE_CREDIT_DIGITAL_SECURITIES);

export const hasManageDistributionPermission = (user: User | null) =>
  userHasPermission(user, ProductPermissionEnum.MANAGE_DISTRIBUTION);

export const hasManageIncomingPaymentsPermission = (user: User | null) =>
  userHasPermission(user, ProductPermissionEnum.MANAGE_INCOMING_PAYMENTS);

export const hasManageTriggerSolutionPermission = (user: User | null) =>
  userHasPermission(user, ProductPermissionEnum.TRIGGER_SOLUTION);

export const hasManageApprovalsPermission = (user: User | null) =>
  userHasPermission(user, ProductPermissionEnum.MANAGE_APPROVALS);

export const hasDownloadStatisticsPermission = (user: User | null) =>
  userHasPermission(user, ProductPermissionEnum.DOWNLOAD_STATISTICS);

export const hasManageRedemptionsPermission = (user: User | null) =>
  userHasPermission(user, ProductPermissionEnum.MANAGE_REDEMPTIONS);

export const currentTokenHasManageCreditDigitalSecuritiesPermission = (token: permissionsTokenType) =>
  currentTokenHasPermission(token, ProductPermissionEnum.MANAGE_CREDIT_DIGITAL_SECURITIES);

export const currentTokenHasManageDistributionPermission = (token: permissionsTokenType) =>
  currentTokenHasPermission(token, ProductPermissionEnum.MANAGE_DISTRIBUTION);

export const currentTokenHasManageIncomingPaymentsPermission = (token: permissionsTokenType) =>
  currentTokenHasPermission(token, ProductPermissionEnum.MANAGE_INCOMING_PAYMENTS);

export const currentTokenHasManageApprovalsPermission = (token: permissionsTokenType) =>
  currentTokenHasPermission(token, ProductPermissionEnum.MANAGE_APPROVALS);

export const currentTokenHasManageRedemptionsPermission = (token: permissionsTokenType) =>
  currentTokenHasPermission(token, ProductPermissionEnum.MANAGE_REDEMPTIONS);

export const currentTokenHasManageDataPermission = (token: permissionsTokenType) =>
  currentTokenHasPermission(token, ProductPermissionEnum.MANAGE_PRODUCT_DATA);
